import React from "react";
import { Alert, AlertTitle, Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import HomeIcon from '@mui/icons-material/Home';

export const Element: React.FC = () => {
  const navigate = useNavigate()

  return <>
    <Helmet>
      <title>Debugging Tools</title>
    </Helmet>
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5" marginBottom={3}>
          Debugging Tools
        </Typography>
        <Alert severity="info" sx={{ marginBottom: 2 }}>
          <AlertTitle>This probably isn't for you...</AlertTitle>
          These tools are for back office use, but you can't do any harm here.
        </Alert>
        <Button
          variant="contained"
          onClick={() => { throw new Error("This is your first error!"); }}
          sx={{ marginTop: 2 }}
        >
          Generate an Error
        </Button>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<HomeIcon />}
          onClick={() => {
            navigate('/')
          }}
          sx={{ marginTop: 3, marginBottom: 2 }}
        >
          Return to the Homepage
        </Button>
      </Box>
    </Container>
  </>
}

export default Element
